/* kb-cart-goal.js */
(function(){
  'use strict';

  // Doppelt laden verhindern
  if (window.KB_CART_GOAL_INIT) return;
  window.KB_CART_GOAL_INIT = true;

  var SEL = '.kb-goal';

  function readTiersFromHTML(el){
    var nodes = el.querySelectorAll('.kb-goal__tier');
    var out = [];
    nodes.forEach(function(n){
      var qty = parseInt(n.getAttribute('data-qty') || '0', 10);
      var labelEl = n.querySelector('.kb-goal__tier-label');
      var label = labelEl ? labelEl.textContent.trim() : '';
      if (qty > 0 && label) out.push({ qty: qty, label: label });
    });
    out.sort(function(a,b){ return a.qty - b.qty; });
    return out;
  }

  function withPercents(tiers){
    var max = tiers.length ? tiers[tiers.length - 1].qty : 0;
    return tiers.map(function(t){
      var p = max ? Math.min(100, (t.qty / max) * 100) : 0;
      return { qty: t.qty, label: t.label, percent: p };
    });
  }

  function progress(count, tiers){
    if (!tiers.length) return { percent: 0, reachedIndex: -1 };
    var max = tiers[tiers.length - 1].qty;
    var clamped = Math.max(0, Math.min(count, max));
    var percent = max ? (clamped / max) * 100 : 0;
    var reachedIndex = -1;
    tiers.forEach(function(t, i){ if (count >= t.qty) reachedIndex = i; });
    return { percent: Math.min(100, percent), reachedIndex: reachedIndex };
  }

  function buildDots(el, tiersP){
    var layer = el.querySelector('.kb-goal__dots');
    if (!layer) return;
    layer.innerHTML = '';
    tiersP.forEach(function(t, i){
      var dot = document.createElement('div');
      dot.className = 'kb-goal__dot';
      dot.style.left = t.percent + '%';
      dot.dataset.index = String(i);
      layer.appendChild(dot);

      var label = document.createElement('div');
      label.className = 'kb-goal__label';
      label.style.left = t.percent + '%';
      label.dataset.index = String(i);
      label.textContent = t.label;
      layer.appendChild(label);
    });
  }

  function setReached(el, reachedIndex){
    el.querySelectorAll('.kb-goal__dot').forEach(function(n){ n.classList.remove('is-reached'); });
    for (var i = 0; i <= reachedIndex; i++){
      var d = el.querySelector('.kb-goal__dot[data-index="' + i + '"]');
      if (d) d.classList.add('is-reached');
    }
  }

  async function fetchPaidItemCount(){
    try{
      var res = await fetch('/cart.js', { headers: { 'Accept':'application/json' }});
      var cart = await res.json();
      if (!cart || !Array.isArray(cart.items)) return 0;
      return cart.items.reduce(function(sum, item){
        var unitFinal = typeof item.final_price === 'number' ? item.final_price : item.price;
        return unitFinal > 0 ? sum + (item.quantity || 0) : sum;
      }, 0);
    }catch(e){
      return 0;
    }
  }

  function paint(el, tiers, count, useTransition){
    var state = progress(count, tiers);
    var fill = el.querySelector('.kb-goal__fill');
    if (fill){
      if (useTransition) fill.classList.add('has-transition');
      fill.style.width = state.percent + '%';
    }
    var bar = el.querySelector('.kb-goal__bar');
    if (bar) bar.setAttribute('aria-valuenow', String(Math.round(state.percent)));
    setReached(el, state.reachedIndex);
  }

  async function render(el){
    try{
      if (!el) return;

      // nur einmal pro Element initialisieren
      if (!el.dataset.kbBuilt){
        var tiers = readTiersFromHTML(el);
        if (!tiers.length) return;
        var tiersP = withPercents(tiers);
        buildDots(el, tiersP);
        el.dataset.kbBuilt = '1';
      }

      // sofortiger First Paint mit serverseitiger Anzahl
      var tiersNow = readTiersFromHTML(el);
      if (!tiersNow.length) return;
      var initial = parseInt(el.getAttribute('data-initial-count') || '0', 10) || 0;
      paint(el, tiersNow, initial, false);

      // Transition erst danach aktivieren
      requestAnimationFrame(function(){
        var fill = el.querySelector('.kb-goal__fill');
        if (fill) fill.classList.add('has-transition');
      });

      // asynchron mit echten bezahlten Items aktualisieren
      var paidCount = await fetchPaidItemCount();
      paint(el, tiersNow, paidCount, true);
    }catch(e){
      // Fehler abfangen, Seite bleibt stabil
      console.warn('KB Cart Goal render error:', e);
    }
  }

  function renderAll(){
    try{
      document.querySelectorAll(SEL).forEach(function(el){ render(el); });
    }catch(e){
      console.warn('KB Cart Goal renderAll error:', e);
    }
  }

  // Events
  document.addEventListener('DOMContentLoaded', renderAll);
  window.addEventListener('pageshow', renderAll);
  document.addEventListener('cart:updated', renderAll);
  document.addEventListener('ajaxProduct:added', renderAll);
  document.addEventListener('shopify:section:load', renderAll);
  document.addEventListener('shopify:section:render', renderAll);
  document.addEventListener('drawer:open', renderAll);
  document.addEventListener('drawer:opened', renderAll);

  // Fallback Observer nur auf den Drawer beschränken
  var target = document.querySelector('cart-drawer');
  if (target){
    var mo = new MutationObserver(function(){ renderAll(); });
    mo.observe(target, { childList:true, subtree:true });
  }
})();
